/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND.
 */
import {
  calculateQuote as calculateDomainQuote,
  nightsBetween,
  STEP_UP_THRESHOLD_CENTS,
} from '../../src/common/booking-domain.mjs';

export const STEP_UP_THRESHOLD = STEP_UP_THRESHOLD_CENTS;
export const DEMO_EMAIL_CODE = '246810';
export { nightsBetween };

export function calculateQuote(selection) {
  return calculateDomainQuote(selection, STEP_UP_THRESHOLD);
}

export function formatMoney(amount) {
  const value = typeof amount === 'number' ? amount : amount.value;
  const currency = typeof amount === 'number' ? 'USD' : amount.currency;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(value / 100);
}
